<template>
    <div :class="stClass">
        <Header :titleL1="headData.titleL1" :titleL2="headData.titleL2" :dateL1="headData.dateL1" :dateL2="headData.dateL2">
        </Header>
        <section class="page-bd">
            <div class="coupon-group">
                <Coupon v-for="(item, index) in couponList" :type="item.type" :index="item.index" :imgUrl="item.imgUrl" :rewardNo="item.rewardNo" :rewardTips="item.rewardTips" :couponDesc="item.couponDesc" :couponBtn="item.couponBtn" :ruleTips="item.ruleTips" :btnLink="item.btnLink" :btnDisable="item.btnDisable" :lang="item.lang" :actId="item.actId" :langObj="item.langObj" :params="item.params"  :successFn="item.successFn" :key="item.index" :state="item.state" :hottagJump="item.hottagJump" :action="item.action" :actionUrl="item.actionUrl"/>
            </div>
        </section>
        <section class="page-ft">
            <p>{{cardComment}}</p><br/>
            <p>{{district}}</p>
        </section>
    </div>
</template>
<script>
import Header from '../components/Header.vue';
import Coupon from '../components/Coupon.vue';
import dialog from '../tools/dialog';
import { wxShare, url, itil, cache } from 'base-libs';
import { getLangConfig } from '../business';
import { hottag } from '../tools/report';

export default {
    name: 'index',
    props: [],
    components: {
        Header,
        Coupon,
    },
    data: function() {
        //用于调试的参数
        if(url.getUrlParam("fstate")){
            window.GLOBAL_Params.state = url.getUrlParam("fstate");
        }
        if(url.getUrlParam("fisHkUser")){
            window.GLOBAL_Params.isHkUser = url.getUrlParam("fisHkUser");
        }
        if(cache.getItemSync("USER_GET_COUPON") === "1" && window.GLOBAL_Params.state == 1){//如果用户已经领取过，就将这个值设置为"2"，避免用户回退，从缓存取出数据
            window.GLOBAL_Params.state = "2";
        }

        return {
            state: "",
            district: "",
            cardComment: "",
            lang: "",
            langObj: {},
            params: window.GLOBAL_Params
        }
    },

    created() {
        getLangConfig().then(({ lang, langObj }) => {
            itil(1345281); //～ITIL 数码通活动页面进入量
            hottag('action_smt_v1_page'); //数码通_页面曝光
            this.lang = lang;
            this.langObj = langObj;

            let that = this;
            let isInWeixin = true;
            //this.params.isHkUser = 0;
            //如果在微信中打开，设置state:1, isHKUser:1
            if (!/micromessenger/.test(navigator.userAgent.toLowerCase()) || "st.moneydata.hk" === location.host) {
                this.state = "1";
                this.params.isHkUser = "1";
                isInWeixin = false
            }
            //this.state = 2;
            this.state = this.params.state;
            document.body.className = `lang-${this.lang} ${isInWeixin ? "":"notweixin"}`;
            this.cardComment = this.langObj.cardComment;
            this.district = this.langObj.specific_district;
            /*dialog({
                icon: 'smile',
                title: this.langObj.dialog_not_hkuser_title,
                text_l1: this.langObj.dialog_not_hkuser_desc,
                sureTxt: this.langObj.dialog_not_hkuser_btn,
                cancelTxt: this.langObj.common_known,
                cancelFn: function(){
                  dialog.remove();
                },
                sureFn: function() {
                    dialog.remove();
                    location.href = that.langObj.jumpRegisterHkwalletLink;
                }
            });*/

            /*dialog({
                icon: 'smile',
                title: this.langObj.dialog_act_end_title,
                text_l1: this.langObj.dialog_act_end_desc,
                sureTxt: this.langObj.dialog_recharge,
                cancelTxt: this.langObj.dialog_act_end_btn,
                sureFn: function() {
                    dialog.remove();
                    location.href = that.langObj.jumpRechageLink;
                },
                cancelFn: function() {
                    dialog.remove();
                }
            });*/

            /*dialog({
                icon: 'smile',
                title: this.langObj.dialog_coupon_send_complete,
                text_l1: this.langObj.dialog_coupon_send_complete_join_other,
                sureTxt: this.langObj.dialog_recharge,
                cancelTxt: this.langObj.dialog_coupon_send_btn,
                sureFn: function() {
                    dialog.remove();
                    location.href = that.langObj.jumpRechageLink;
                },
                cancelFn: function() {
                    dialog.remove();
                }
            });*/

            //
            /**
             * 1-可领用
             2-已领用
             3-已派完（达到活动限额）
             4-活动未开始
             5-活动已结束
             */
            if (this.params.isHkUser * 1 === 0) {
                dialog({
                    icon: 'smile',
                    title: this.langObj.dialog_not_hkuser_title,
                    text_l1: this.langObj.dialog_not_hkuser_desc,
                    sureTxt: this.langObj.dialog_not_hkuser_btn,
                    cancelTxt: this.langObj.common_known,
                    cancelFn: function() {
                        hottag("action_smt_openhkwlater");
                        dialog.remove();
                    },
                    sureFn: function() {
                        hottag("action_smt_openhkw");
                        setTimeout(()=>{
                            location.href = that.langObj.jumpRegisterHkwalletLink;
                        }, 100)
                        dialog.remove();
                    }
                });
                hottag('action_smt_v1_nothkuser');
            } else if (this.state * 1 === 5) {
                dialog({
                    icon: 'smile',
                    title: this.langObj.dialog_act_end_title,
                    text_l1: this.langObj.dialog_act_end_desc,
                    sureTxt: this.langObj.dialog_recharge,
                    cancelTxt: this.langObj.dialog_act_end_btn,
                    sureFn: function() {
                        setTimeout(()=>{
                            location.href = that.langObj.jumpRechageLink;
                        }, 100)
                        dialog.remove();
                    },
                    cancelFn: function() {
                        dialog.remove();
                    }
                });
            } else if (this.state * 1 === 3) {
                dialog({
                    icon: 'smile',
                    title: this.langObj.dialog_coupon_send_complete,
                    text_l1: this.langObj.dialog_coupon_send_complete_join_other,
                    sureTxt: this.langObj.dialog_recharge,
                    cancelTxt: this.langObj.dialog_coupon_send_btn,
                    sureFn: function() {
                        setTimeout(()=>{
                            location.href = that.langObj.jumpRechageLink;
                        }, 100)
                        dialog.remove();
                    },
                    cancelFn: function() {
                        dialog.remove();
                    }
                });
            } else if (this.state * 1 === 4) {
                dialog({
                    icon: 'smile',
                    title: this.langObj.dialog_act_not_start_title,
                    sureTxt: this.langObj.dialog_act_end_btn,
                    sureFn: function() {
                        dialog.remove();
                    }
                });
            }

            //dialog_ok
            //领取成功
            /*dialog({
                icon: 'ok',
                title: this.langObj.dialog_get_coupon_success_title,
                text_l1: this.langObj.dialog_get_coupon_success_desc_line1,
                text_l2: this.langObj.dialog_get_coupon_success_desc_line2,
                sureTxt: this.langObj.dialog_get_coupon_success_btn,
                sureFn: function() {
                    dialog.remove();
                }
            });*/

            //领取失败
            /*dialog({
                icon: 'error',
                //title: this.langObj.err_system_busy,
                text_l1: this.langObj.err_system_busy,
                sureTxt: this.langObj.dialog_act_end_btn,
                sureFn: function() {
                    dialog.remove();
                }
            });*/

            wxShare({
                imgUrl: location.protocol + "//qzonestyle.gtimg.cn/qzone/qzactStatics/imgs/20181017183839_3d4511.png",
                url: location.href.replace(/ADTAG=(\w+.){3}\w+/, "ADTAG=wphk.act.smt.share"), //设置分享的ADTAG
                desc: langObj.main_title_line1,
                title: 'Top up & Remit！'
            }, function (res) {
                let errmsg = (res.errMsg || "").replace(/\:/g, "_")
                MtaH5.clickStat('hkwallet_act201810_smartone_share', { 'errmsg': errmsg});
            });
        });
    },
    computed: {
        couponList: function() {
            console.log("couponList .....xxxx....computed ");
            let list = [];
            let colors = ['yellow', 'orange', 'blue'];

            for (let i = 0; i < 3; i++) {
                let item = {
                    index: i,
                    type: colors[i],
                    imgUrl: this.langObj[`coupon_${i+1}_img`]?(this.langObj[`coupon_${i+1}_img`] + "?1234") : "",
                    rewardNo: this.langObj[`reward_${i+1}`],
                    rewardTips: this.langObj[`reward_${i+1}_tips`],
                    couponDesc: this.langObj[`coupon_${i+1}_desc`],
                    couponBtn: this.langObj[`coupon_${i+1}_btn`],
                    ruleTips: this.langObj.rule_tips,
                    action: this.langObj[`coupon_${i+1}_action`],
                    actionUrl: this.langObj[`coupon_${i+1}_action_url`],
                    hottagJump: `action_smt_v1_check_${i+1}`,  //用来跳转链接的hottag
                    btnLink: this.langObj[`coupon_${i+1}_btn_link`] || '',
                    btnDisable: false, //按钮是否disable, status为2的时候，是已领用状态，需要灰掉按钮
                    state: this.state + "",
                    lang: this.lang,
                    params: this.params,
                    langObj: this.langObj
                };
                if (i === 0 && this.state * 1 === 2) { //status为2的时候，是已领用状态
                    item.couponBtn = this.langObj[`coupon_btn_done`];
                    //item.btnDisable = true; //按钮是否disable, status为2的时候，是已领用状态，需要灰掉按钮
                }

                if (i === 0 && this.state * 1 === 3) { //status为2的时候，是已领用状态
                    item.couponBtn = this.langObj[`dialog_coupon_send_complete`];
                    item.btnDisable = true; //按钮是否disable, status为2的时候，是已领用状态，需要灰掉按钮
                }

                if (this.state * 1 === 5) { //status为2的时候，是已领用状态
                    item.couponBtn = this.langObj[`dialog_act_end_title`];
                    item.btnDisable = true; //按钮是否disable, status为2的时候，是已领用状态，需要灰掉按钮
                }

                if (i === 0 && this.state * 1 === 4) { //status为2的时候，是已领用状态
                    item.btnDisable = true; //按钮是否disable, status为2的时候，是已领用状态，需要灰掉按钮
                }

                if (i === 0) { //status为2的时候，是已领用状态
                    item.actId = this.params.act_listid;
                    let that = this;
                    item.successFn = () => {
                        //alert(1);
                        that.state = "2";
                        window.GLOBAL_Params.state = "2";
                        cache.setItemSync("USER_GET_COUPON", "1", 1000*60*60*24*30);
                    }
                }
                list.push(item);
            }
            return list;
        },
        headData: function() {
            return {
                titleL1: this.langObj.main_title_line1,
                titleL2: this.langObj.main_title_line2,
                dateL1: this.langObj.act_date_line1,
                dateL2: this.langObj.act_date_line2
            }
        },
        stClass: function() {
            return `st-box lang-${this.lang}`;
        }

    }
};
</script>